import { AddCircle } from 'iconsax-react';
import React from 'react';
import InfoText from './InfoText';

type Props = {
  text: string;
  onClick: () => void;
  className?: string;
  id?: string;
  type?: 'button' | 'submit' | 'reset';
  disblaeBtn?: boolean;
};

const AddItemBtn = ({
  onClick,
  text,
  className,
  id,
  type = 'button',
  dataTestId,
  disblaeBtn,
}: Props & { dataTestId?: string }) => {
  return (
    <button
      type={type}
      className={
        'flex items-center justify-center bg-transparent gap-2 transition-opacity hover:opacity-80' +
        ' ' +
        (className || '')
      }
      disabled={disblaeBtn}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      id={id}
      data-testid={dataTestId}
    >
      <AddCircle size="20" color="#47A167" variant="Bold" />
      <InfoText text={text} className="!text-sm !font-bold !text-[#47A167] !m-0 !p-0" />
    </button>
  );
};

export default AddItemBtn;
